import React, { useState } from 'react';

import CoachRosterList from '@/components/mentor/coach/CoachRosterList';
import CoachRosterSearch from '@/components/mentor/coach/CoachRosterSearch';
import { useTranslation } from '@/config/i18n';

const MentorCoachManagementPage: React.FC = () => {
  const [t] = useTranslation('');
  const [searchTrigger, setSearchTrigger] = useState(0);

  return (
    <>
      <div className="header-top flex items-center justify-between">
        <h2 className="title">{t('menu.mentor_coach_management')}</h2>
      </div>
      <CoachRosterSearch onSearch={() => setSearchTrigger((prev) => prev + 1)} />
      <CoachRosterList searchTrigger={searchTrigger} />
    </>
  );
};

export default MentorCoachManagementPage;
